<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Add to Schedule</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <form>
    <div class="form-group" [formGroup]="form">
      <div class="row">
        <div class="col-md-6" >
          <div class="form-group">
            <label>Start Time<span class="required-star"> *</span></label>
            <p-calendar class="form-control"
            formControlName="scheduledStartTime"
            dateFormat="dd/mm/yy"
            [minDate]="minDate"
            [showTime]="true" [hideOnDateTimeSelect]="false"
            panelStyleClass="popupAboveDate-schedule-time"
            (onClose)="onStartTimeChange()">
          </p-calendar>
          </div>
          </div>
        </div>

        <div class="row">
         <div class="col-md-6" >
          <div class="form-group">
            <label>End Time<span class="required-star"> *</span></label>
            <p-calendar class="form-control dateFieldEmphasis"
            [ngClass]="endTimeShowChangeOccurred ? 'dateFieldEmphasisOn' : ''"
            formControlName="scheduledEndTime"
            dateFormat="dd/mm/yy"
            [minDate]="minDate"
            panelStyleClass="popupAboveDate-schedule-time"
            [showTime]="true" [hideOnDateTimeSelect]="false">
          </p-calendar>
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-3 p-0">
        <div class="form-group">
          <label>Description of work<span *ngIf="needsApproval" class="required-star"> *</span></label>
          <textarea type="text" class="form-control" formControlName="reason"></textarea>
          <small *ngIf="!needsApproval" class="form-text text-muted text-right">{{ (form.controls['reason'].value || '').length }} / {{ directReasonMaxLength }} characters</small>
          <div *ngIf="!needsApproval && form.controls['reason'].errors?.maxlength" class="text-danger">
            Description of work must be 300 characters or fewer.
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-3 p-0" *ngIf="needsApproval">
        <div class="form-group">
          <label>Name of workers carrying out work<span class="required-star"> *</span></label>
          <textarea type="text" class="form-control" formControlName="workers"></textarea>
          <small class="form-text text-muted text-right">Combined total: {{ combinedReasonLength }} / {{ combinedReasonMaxLength }} characters</small>
          <div *ngIf="form.errors?.combinedReasonTooLong" class="text-danger">
            Description of work and worker names must be 300 characters or fewer in total.
          </div>
        </div>
      </div>
      <div *ngIf="needsApproval">
        This is subject to approval by the site operator
      </div>
      <div *ngIf="validationErrors.length" class="validation-box text-danger">
        Please fix the following validation problems to continue:
        <div *ngFor="let validationError of validationErrors">- {{validationError.message}}</div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onSubmit()" [disabled]="saveInProgress || !form.valid" class="btn btn-sm btn-success">Save</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
